import axiosInstance from "../axiosInterceptor";

const flattenData = (data) => {
    if (!data || data.length === 0) return [];
    return data.flatMap((parent) => {
        const result = [{ id: parent.id, name: parent.name }];
        if (parent.children && parent.children.length > 0) {
            result.push(...parent.children);
        }

        return result;
    });
};

export const mergeAttributeData = (attributeDefaultData, attributes) => {
    try {
        let mergedData = [];
        if (Array.isArray(attributeDefaultData) && attributeDefaultData.length > 0) {
            mergedData = [...mergedData, ...attributeDefaultData];
        }

        if (Array.isArray(attributes) && attributes.length > 0) {
            mergedData = [...mergedData, ...attributes];
        }
        return mergedData;
    } catch (error) {
        return [];
    }
};


// const AttributeStructuredata = (attributesArray) => { 
//     const formattedAttributes = attributesArray.reduce((acc, attr) => {
        
//         acc[attr.attribute_id] = {
//             attribute_id: attr.attribute_id,
//             attributeValue: attr.attributeValue,
//         };
//         return acc;
//     }, {});

//     return formattedAttributes;
// };

const AttributeStructuredata = (attributesArray) => { 
    const formattedAttributes = attributesArray.reduce((acc, attr) => {
        acc[attr.attribute_id] = {
            attribute_id: attr.attribute_id,
            attributeValue: attr.attributeValue,
        };
        return acc;
    }, {});
    return formattedAttributes;
};

const StructureCategories = (categories) => {
    const selectedCategories = {};
    const selectedSubcategories = {};

    if (Array.isArray(categories) && categories.length > 0) {
        categories.forEach((category) => {
            if (category?.parentId) {
                selectedSubcategories[category.id] = true;
            } else {
                selectedCategories[category.id] = true;
            }
        });
    }

    return { selectedCategories, selectedSubcategories };
};

const fetchAllData = async (url, setfunc, data = null, setloading = null,setNextPosition) => {
    if (setloading) {
        setloading(true);
    }
    try {
        let response;
        if (data) {
            response = await axiosInstance.post(url, data);
        } else {
            response = await axiosInstance.get(url);
        }

        const { data: responseData } = response.data;
        if (response.status === 200) {
       
            setfunc(responseData);
            if (setNextPosition) {
                setNextPosition(responseData.length);
            }
        }
    } catch (error) {
        const responseError = error?.response?.data?.message || error.message;
        return responseError;
    }
    finally {
        if (setloading) {
            setloading(false);
        }
    }
};

// const transformAttributeData = (selectedValues) => { 
//     return Object.values(selectedValues).map((item) => ({
//         attribute_id: item.attribute_id,
//         attributeValue: item.attributeValue.map((child) => ({
//             id: child.id,
//             value: child.value || "",
//         })),
//     }));
// };


//  const transformAttributeData = (selectedValues) => {
//   if (!selectedValues || typeof selectedValues !== "object") return [];

//   const transformed = [];

//   Object.keys(selectedValues).forEach((key) => {
//     const item = selectedValues[key];

//     // ✅ Case 1: Multiple Select / Dropdown
//     if (item && typeof item === "object" && item.attribute_id) {
//       if (
//         Array.isArray(item.attributeValue) &&
//         item.attributeValue.length > 0
//       ) {
//         transformed.push({
//           attribute_id: item.attribute_id,
//           attributeValue: item.attributeValue.map((val) => ({
//             id: val.id || null,
//             value: val.value || "",
//           })),
//         });
//       }
//     }

//     // ✅ Case 2: Textfield (direct string value)
//     else if (typeof item === "string" && item.trim() !== "") {
//       transformed.push({
//         attribute_id: key,
//         attributeValue: [
//           {
//             id: null,
//             value: item.trim(),
//           },
//         ],
//       });
//     }
//   });

//   return transformed;
// };


const transformAttributeData = (selectedValues) => {
  if (!selectedValues || typeof selectedValues !== "object") return [];

  const transformed = [];

  Object.keys(selectedValues).forEach((key) => {
    const item = selectedValues[key];

    if (!item) return;

    // ✅ If already structured object (Dropdown / MultipleSelect / TextField)
    if (
      typeof item === "object" &&
      item.attribute_id &&
      Array.isArray(item.attributeValue)
    ) {
      const filteredValues = item.attributeValue.filter(
        (val) => val && (val.id || (val.value && val.value.trim() !== ""))
      );

      if (filteredValues.length > 0) {
        transformed.push({
          attribute_id: item.attribute_id,
          attributeValue: filteredValues.map((val) => ({
            id: val.id || null,
            value: val.value?.trim() || "",
          })),
        });
      }
    }
  });

  return transformed;
};

export { flattenData, AttributeStructuredata, StructureCategories, fetchAllData, transformAttributeData }